const items = [
  {
    text: 'Legal',
    subnav: [
      {
        text: 'Service Agreements',
        href: 'http://www.dish.com/service-agreements',
      },
      {
        text: 'Terms and Conditions',
        href: 'https://www.dish.com/terms-conditions',
      },
      { text: 'Do Not Sell My Info', href: '/do-not-sell' },
      { text: 'Explore Dish', href: 'https://www.dish.com/' },
    ],
  },
]

export default items
